import { loadSong } from './song';

export const ADD_TO_SONG_LIST = 'ADD_TO_SONG_LIST';

export const LOAD_SONG_LIST_REQUEST = 'LOAD_SONG_LIST_REQUEST';
export const LOAD_SONG_LIST_SUCCESS = 'LOAD_SONG_LIST_SUCCESS';
export const LOAD_SONG_LIST_FAILURE = 'LOAD_SONG_LIST_FAILURE';

export const SAVE_SONG_LIST_REQUEST = 'SAVE_SONG_LIST_REQUEST';
export const SAVE_SONG_LIST_SUCCESS = 'SAVE_SONG_LIST_SUCCESS';
export const SAVE_SONG_LIST_FAILURE = 'SAVE_SONG_LIST_FAILURE';

export function loadSongList(alsoLoadFirstSong = false) {
  return (dispatch) => {
    dispatch({ type: LOAD_SONG_LIST_REQUEST });

    return new Promise((resolve, reject) => {
      try {
        resolve(JSON.parse(localStorage.getItem('songlist') || '[]'));
      } catch (err) {
        reject(err);
      }
    })
      .then((songlist) => {
        dispatch({ type: LOAD_SONG_LIST_SUCCESS, songlist });
        // Load the first song
        if (alsoLoadFirstSong && songlist.length > 0) {
          dispatch(loadSong(songlist[0]));
        }
      })
      .catch((err) => {
        dispatch({ type: LOAD_SONG_LIST_FAILURE, err });
      });
  };
}

export function saveSongList() {
  return (dispatch, getState) => {
    dispatch({ type: SAVE_SONG_LIST_REQUEST });

    new Promise((resolve, reject) => {
      try {
        localStorage.setItem('songlist', JSON.stringify(getState().songlist));
        resolve();
      } catch (err) {
        reject(err);
      }
    })
      .then(() => {
        dispatch({ type: SAVE_SONG_LIST_SUCCESS });
      })
      .catch((err) => {
        dispatch({ type: SAVE_SONG_LIST_FAILURE, err });
      });
  };
}

export function addToSongList(filename, save = false) {
  const action = { type: ADD_TO_SONG_LIST, filename };
  if (save) {
    return (dispatch) => {
      dispatch(action);
      dispatch(saveSongList());
    };
  }
  return action;
}



// WEBPACK FOOTER //
// ./src/actions/songlist.js